export var Events;
(function (Events) {
    function bindScope(client) {
        return {
            DownloadEvent: client.bindCallable({
                name: 'DownloadEvent',
                scope: 'events',
                path: '/api/events/download-event',
                method: 'post',
                kind: 'api',
            }),
            DownloadEventsSummary: client.bindCallable({
                name: 'DownloadEventsSummary',
                scope: 'events',
                path: '/api/events/download-events-summary',
                method: 'post',
                kind: 'api',
            }),
        };
    }
    Events.bindScope = bindScope;
})(Events || (Events = {}));
//# sourceMappingURL=events.js.map